import { Injectable, ViewContainerRef } from '@angular/core';
import { Modal, BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { ShowImgModalComponent } from './show-img-modal.component';
import { overlayConfigFactory } from 'ngx-modialog';

@Injectable()
export class ShowImgModalService {
    constructor(public modal: Modal) {}

    openDialog(strTitle: string, strImgUrl: string, objPostData: Object, viewContainer:ViewContainerRef) {
    	(this.modal.overlay as any).defaultViewContainer = viewContainer;
        return this.modal.open(ShowImgModalComponent, overlayConfigFactory({
        	strTitle: strTitle,
        	strImgUrl: strImgUrl,
        	objPostData: objPostData
        }, BSModalContext));
    };
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/show-img-modal/show-img-modal.service.ts